import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import InteractiveSpeakingComp from '../components/InteractiveSpeakingComp';

function InteractiveSpeaking() {
  return (
    <>
      <Navbar />
      <InteractiveSpeakingComp />
      <Footer />
    </>
  );
}

export default InteractiveSpeaking;
